import css from 'styled-jsx/css';
import Theme, { colors, fontSizes } from '../../../themes/index';

export default css`
  .filter-tag-item {
    align-items: center;
    background: transparent;
    border: 1px solid ${colors.grayDeep};
    border-radius: 20px;
    color: ${colors.grayDeep};
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    font-size: ${fontSizes.small};
    height: 30px;
    margin-right: 10px;
    padding: 10px;
    width: auto;
    min-width: 0;
  }

  .filter-tag-item.jobs {
    border: none;
    background: ${Theme.jobs.main};
    color: ${colors.white};
  }

  .icon-wrapper {
    border-radius: 32px;
    background: rgba(0, 0, 0, 0.5);
  }

  .close.jobs {
    fill: ${Theme.jobs.main};
  }

  p {
    display: inline;
    margin: 0 10px 0 0;
    font-weight: 600;
    text-transform: uppercase;
    white-space: nowrap;
  }
`;



// WEBPACK FOOTER //
// ./app/common/FilterTags/item/styles.js